import React, { useState } from 'react';
import { Link } from 'react-router-dom';
import { motion } from "framer-motion";
import { useSelector } from 'react-redux';


import { BiChevronDown } from "react-icons/bi"

function MenuItem({ item, onToggle }) {
	const [isOpen, setIsOpen] = useState(false);

	const handleToggle = () => {
		setIsOpen(!isOpen);
		onToggle(item.name); // Ana menü öğesine tıklandığında, bu işlevi çağırarak alt menüyü açın/kapatın.
	};


	if (!item.submenu && !item.url) {
		return (
			<li className="mb-3 mt-3">
				<span className='text-slate-300  text-xs font-semibold'>{item.name}</span>
			</li>
		);
	}

	if (!item.submenu) {
		// Alt menü yoksa, sadece bağlantıyı döndürün
		return (
			<>
			<li className="relative flex items-center">
				<Link to={item.url} className='hover:outline-dotted focus:outline-dotted outline-1 outline-offset-2 outline-slate-200  flex w-full relative items-center text-slate-500   hover:bg-slate-100 0 px-2 py-2 rounded-md transition-all duration-200'>

					{
						item.icon && (
							<span className='text-xl w-8 text-[#b09c73]'>{item.icon}</span>
						)						
					}

					<span className='flex-grow text-sm '>{item.name}</span>
				</Link>
			</li>   
		  </>
		);
	}



	// Alt menü varsa, alt menüyü oluşturun
	return (
		<li className="relative flex flex-col items-center">
			<span onClick={handleToggle} className='hover:outline-dotted focus:outline-dotted outline-1 outline-offset-2 outline-slate-200  flex w-full relative items-center text-slate-500  hover:bg-slate-100 px-2 py-2.5 rounded-md cursor-pointer transition-all duration-200'>
				{
					item.icon && (
						<span className='text-xl w-8 text-[#b09c73]'>{item.icon}</span>
					)
				}

				<span className='flex-grow text-sm'>{item.name}</span>
				<span className='text-slate-500'><BiChevronDown /></span>
			</span>
			<motion.ul
				animate={
					isOpen
						? {
							height: "fit-content",
						}
						: {
							height: 0,
						}
				}
				className=' flex w-full h-0 py-1 px-1 flex-col overflow-hidden'>
				{item.submenu.map((subItem, index) => (
					<MenuItem key={index} item={subItem} onToggle={onToggle} />
				))}
			</motion.ul>
		</li>
	);
}


const SubMenu = ({ data }) => {
    const role = useSelector((state) => state.auth);
    const filteredData = data.filter((item)=> item.roles && item.roles.includes(role.userRole))


	const [openMenus, setOpenMenus] = useState([]);
	const handleToggle = (menuName) => {
		if (openMenus.includes(menuName)) {
			setOpenMenus(openMenus.filter((name) => name !== menuName));
		} else {
			setOpenMenus([...openMenus, menuName]);
		}
	};
	return (

		<ul className='flex flex-col gap-y-2'>
			{filteredData.map((item, index) => (
				<MenuItem
					key={index}
					item={item}
					onToggle={handleToggle}
				/>
			))}
		</ul>

	);
};

export default SubMenu;
